import React, { useState } from "react";
import { SketchPicker } from "react-color";

import "./style.scss";

interface IProps {
  defaultColor: Color;
  handleSubmit: (arg: Color) => void;
  className?: string;
  disabled?: boolean;
}

interface RGBColor {
  a?: number;
  b: number;
  g: number;
  r: number;
}

type Color = RGBColor;

interface IColorProp {
  rgb: Color;
}

export default function ColorPicker(props: IProps) {
  const { defaultColor, handleSubmit, className, disabled = false } = props;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState(
    defaultColor || { r: 255, g: 255, b: 255, a: 1 }
  );

  const handleColorChange = (c: IColorProp) => {
    setColor(c.rgb);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
    handleSubmit(color);
  };

  const handleToggle = () => {
    if (!disabled) {
      setDisplayColorPicker(!displayColorPicker);
      handleSubmit(color);
    }
  };

  return (
    <div className="color-picker__container">
      <div
        data-test-id="color_picker"
        className="color-picker-label"
        style={{
          background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
        }}
        onClick={handleToggle}
      ></div>
      {displayColorPicker && <div data-test-id="close" className="mask" onClick={handleClose} />}
      {displayColorPicker && (
        <div className={`picker-wrapper ${className}`}>
          <SketchPicker data-test-id="color_change" color={color} onChange={handleColorChange} />
        </div>
      )}
    </div>
  );
}
